export const testAnswerSingleResourceType = "test_answer_single" as const;

export const completeTutorialTestPath = (
  companyId: string,
  tutorialId: string
) => {
  return `/companies/${companyId}/tutorial_progress/${tutorialId}/complete_test`;
};
